var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckSquare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.6245 19.9206L21.9995 25.2956L39.9162 7.37897",
    stroke: "#3671CC",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M38.1245 21.7123V34.2539C38.1245 35.2043 37.747 36.1157 37.075 36.7877C36.403 37.4598 35.4915 37.8373 34.5412 37.8373H9.45784C8.50749 37.8373 7.59605 37.4598 6.92405 36.7877C6.25204 36.1157 5.87451 35.2043 5.87451 34.2539V9.17061C5.87451 8.22025 6.25204 7.30882 6.92405 6.63681C7.59605 5.96481 8.50749 5.58728 9.45784 5.58728H29.1662",
    stroke: "#3671CC",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckSquare);
export default __webpack_public_path__ + "static/media/check-square.ab6472164e49860b95f86b4b01b99e3b.svg";
export { ForwardRef as ReactComponent };